import styled from '@emotion/styled';

export const PageContainer = styled.div`
  display: grid;
  grid-template-rows: auto 1fr auto;
  min-height: 100vh;
  background-color: ${({ theme }) => theme.customTheme.colors.background};
`;
